package ui.campaign.detailv2.editor.wrapper

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import api.CampaignState
import api.CampaignType
import common.frontend.api.Io
import ui.campaign.detailv2.editor.CampaignEditorVM
import ui.campaign.detailv2.editor.feature.FeatureCounter


class CampaignWrapperE(
    private val companyId: Long,
    val data: Io.Campaign,
    apps: Io.ListingApp,
    counter: FeatureCounter
) {

    val isNewCampaign = data.id <= 0L
    val originName = data.name

    var err by mutableStateOf(false)

    val type = CampaignType[data.settings.type]
    val isSlotType = type == CampaignType.SLOT
    val isImpressionType = type == CampaignType.IMPRESSION
    val isStateOfDraft = CampaignState.DRAFT match data.state

    val general = CampaignWrapperEGeneral(data)
    val location = CampaignWrapperELocation(
        data = data,
        counter = counter
    )

    val visual = CampaignWrapperEVisual(
        companyId = companyId,
        campaign = data,
        devicesScreenRatio = { location.selectedScreenRatios() })

    val visualDynamic = CampaignWrapperEVisualDynamic(
        companyId = companyId,
        campaign = data,
        devicesScreenRatio = { location.selectedScreenRatios() })

    val apps = CampaignWrapperEApplication(
        campaign = data,
        apps = apps,
    )

    val offsets = CampaignWrapperEOffsets(data)

    val miniApp = CampaignWrapperEMiniApp(data)

    private fun validateChange() {
        err = general.err || location.err || visual.err || offsets.err || visualDynamic.err || apps.err || miniApp.err
    }


    suspend fun extractErrors(tabs: List<CampaignEditorVM.Tab>): String? {
        validateChange()
        if (!err) return null
        else {
            for (tab in tabs) {
                when (tab) {
                    CampaignEditorVM.Tab.General00 -> {
                        if (general.err) return general.extractErr()
                    }

                    CampaignEditorVM.Tab.Location01 -> {
                        if (location.err) return location.extractErr()
                    }

                    CampaignEditorVM.Tab.Visual02 -> {
                        if (visual.err) return visual.extractErr()
                    }

                    CampaignEditorVM.Tab.Offset03 -> {
                        if (offsets.err) return offsets.extractErr()
                    }

                    CampaignEditorVM.Tab.DynamicVisual04 -> {
                        if (visualDynamic.err) return visualDynamic.extractErr()
                    }

                    CampaignEditorVM.Tab.Application06 -> {
                        if (apps.err) return apps.extractErr()
                    }

                    CampaignEditorVM.Tab.MiniApp07 -> {
                        if (miniApp.err) return miniApp.extractErr()
                    }

                    CampaignEditorVM.Tab.Effect05 -> TODO()
                    CampaignEditorVM.Tab.Summary08 -> Unit
                }
            }
            return null
        }
    }

    fun extract(): Io.Campaign {
        location.trimDaysExclusion(data.start.date, data.end.date)
        val impressionExpected = location.locations.state
            .map { it.devices.state.filter { it.active.state } }
            .flatten()
            .sumOf { it.impressionSum }
        return data.copy(
            impressionExpected = impressionExpected,
            visuals = (visual.extract() + visualDynamic.extract()).toMutableList(),
            apps = apps.extract().toMutableList(),
        )
    }
}